import React from 'react';
import { Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, Row, Col, Button, ButtonGroup } from 'reactstrap';
import { matchesISBNString } from '../helpers/Validations';
import * as warnings from '../constants/ValidationWarnings';

export default class ImportModal extends React.PureComponent {
  constructor(props) {
    super(props);
    const shouldOpen = this.props.importData && Object.keys(this.props.importData).length > 0;
    this.state = {
      open:  shouldOpen,
      validationErrors: ''
    };
    if (shouldOpen){
      let fields = Object.keys(this.props.importData);
      for (let i = 0; i < fields.length; ++i) {
          const field = fields[i];
          if (this.props.importData && this.props.importData[field]){
            if ((field == "isbn" || field == "eisbn") && !matchesISBNString(this.props.importData[field]) ) {
              this.state['selected' + field] = false;
              this.state['disabled' + field] = true;
              this.state.validationErrors += field + ": " + warnings.ISBN;
            } else{
              this.state['selected' + field] = true;
              this.state['disabled' + field] = false;
            }
          }
      }
    }
  }

  handleChange(e,f) {
    this.setState({ [f]: !this.state[f] });
  }

  importDataFormRow = (field) => {
    if (this.props.importData && this.props.importData[field]){
      var color = this.props[field] == this.props.importData[field] ? 'text-success' : 'text-danger'
      return(
        <Row>
          <Col sm={2}>
            <FormGroup check>
              <Input type="checkbox" className="checkbox-inline" checked={this.state['selected' + field]} onChange={(value) => this.handleChange(value, 'selected' + field)}/>
              <Label>{field}</Label>
            </FormGroup>
          </Col>
          <Col sm={5}>{this.props[field]}</Col>
          <Col sm={5}><span className={color}>{this.props.importData[field]}</span></Col>
        </Row>
      );
    }
  }

  importIsbnFormRow = (field, type) => {
    const isbn = this.props.isbns ? this.props.isbns.find(opt => opt.category === type) : null;
    if (this.props.importData && this.props.importData[field]){
      var color = isbn && isbn.number == this.props.importData[field] ? 'text-success' : 'text-danger';
      var fieldColor = this.state['disabled' + field] ? 'text-muted' : null;
      return(
        <Row>
          <Col sm={2}>
            <FormGroup check>
              <Input type="checkbox" className="checkbox-inline" checked={this.state['selected' + field]} disabled={this.state['disabled' + field]} onChange={(value) => this.handleChange(value, 'selected' + field)}/>
              <Label><span className={fieldColor}>{field}</span></Label>
             </FormGroup>
          </Col>
          <Col sm={5}>{isbn ? isbn.number : ''}</Col>
          <Col sm={5}><span className={color}>{this.props.importData[field]}</span></Col>
        </Row>
      );
    }
  }

  submit = () => {
    const fields = ["code", "title", "publisher"]
    for (let i = 0; i < fields.length; ++i) {
        const field = fields[i];
        if (this.props.importData && this.props.importData[field] && this.state['selected' + field]){
          this.props.projectUpdate(field, this.props.importData[field]);
        }
    }
    if (this.props.importData && this.props.importData.isbn && this.state.selectedisbn){
      this.modifyISBN('isbn', 'print', this.props.importData.isbn)
    }
    if (this.props.importData && this.props.importData.eisbn && this.state.selectedeisbn){
      this.modifyISBN('eisbn', 'epub', this.props.importData.eisbn)
    }
    //This causes a major issue with the testing suite for whatever reason. 
    this.setState({ open: false });
  }

  modifyISBN(field, category, number){
    const isbn = this.props.isbns.find(opt => opt.category === category);
    if (isbn){
      this.props.updateIsbn(isbn.id, 'number', number);
    }
    else{
      this.props.createIsbn({category, number});
    }

  }

  cancel = () => {
    this.setState({ open: false });
  }

  render() {
    return (<Modal
      isOpen={this.state.open}
      ref="ImportModal"
      size="xl"
    >
      <div className="modal-header">
        <h3 className="modal-header-title">
          {'Review changes before overwriting' }
        </h3>
      </div>
      <ModalBody>
        <Form>
          <Row>
            <Col sm={2}><b>Update Metadata?</b></Col>
            <Col sm={5}><b>Current</b></Col>
            <Col sm={5}><b>Updated</b></Col>
          </Row>
          {this.importDataFormRow("code")}
          {this.importDataFormRow("title")}
          {this.importDataFormRow("publisher")}
          {this.importIsbnFormRow("isbn", "print")}
          {this.importIsbnFormRow("eisbn", "epub")}
        </Form>
        <p>{this.state.validationErrors }</p>
      </ModalBody>
      <ModalFooter>
        <ButtonGroup>
          <Button onClick={this.submit} color="success" >Update Project</Button>
          <Button onClick={this.cancel}>Cancel</Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>);
  }
}
